var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-carousel',{attrs:{"interval":5000,"arrow":"always","height":_vm.bannerHight+'px'}},_vm._l((_vm.srcArr),function(item){return _c('el-carousel-item',{key:item.index},[_c('img',{attrs:{"src":item.path,"alt":"","height":"500","width":"100%"}})])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4df29529","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/views/knowledge/knowBanner.vue
// module id = null
// module chunks = 